import { ref, onMounted, onUnmounted } from 'vue'
import type { Ref } from 'vue'
import type { MenuPrivate, MenuPrivateLink } from '../entities/MenuPrivate'
import { PRIVATE_MENU } from '../entities/MenuType'
import { contentCall } from './useMenu'
import type {
  AuthUserTypeKeys,
  AuthUser,
} from '~~/modules/auth/entities/AuthUser'
import { useUserStore } from '~~/modules/auth/stores/userStore'

export function useMenuPrivate() {
  const MenuPrivateInstance: Ref<MenuPrivate> = ref(null)
  const userStore = useUserStore()
  const unsubscribe = userStore.$subscribe(() => {
    init()
  })

  onUnmounted(() => {
    unsubscribe()
  })

  // @ts-ignore
  const menuAdapter = (rawData, user: AuthUser<any>): MenuPrivate => {
    // @ts-ignore
    const filteredData: MenuPrivate = rawData.filter(item => {
      if (item.id === 'bookings' && user.type === 'traveler') {
        return user.params.has_booking
      } else if (item.id === 'webpage' && user.type === 'owner') {
        return user.params.has_webpage
      }
      return true
    })

    const route = useRoute()
    const selectedItemId = route.meta.privateMenuItem

    // @ts-ignore
    const parsedData: MenuPrivate = filteredData.map(item => {
      const parsedData: MenuPrivateLink = {
        id: item.id,
        name: item.name,
        // @ts-ignore
        href: item.href.replace(':id', user.id.toString()),
        icon: item.icon,
        selected: false,
        unread: 0,
        target: item.target,
      }

      if (item.id === selectedItemId) {
        parsedData.selected = true
      }

      if (item.id === 'messages') {
        parsedData.unread = user.params.unread_messages
      }

      if (user.type === 'owner') {
        if (item.id === 'webpage') {
          parsedData.href = `${parsedData.href}/${user.params.has_webpage}`
        } else if (item.id === 'bookings') {
          parsedData.unread = user.params.unread_bookings
        } else if (item.id === 'helpCenterWhatsapp') {
          parsedData.href = routesExternal().whatsapp({
            prefix: '34',
            phoneNumber: '634678573',
            text: t('menu.private_menu.helpCenterWhatsappMessage', {
              id: user.id,
            }),
          })
        }
      }

      return parsedData
    })

    return parsedData
  }

  const init = async () => {
    if (userStore.getLogged === true) {
      const data = await contentCall(
        PRIVATE_MENU,
        userStore.getUserdata.type as AuthUserTypeKeys,
      )
      const dataAdapted = menuAdapter(data, userStore.getUserdata)
      MenuPrivateInstance.value = dataAdapted
    }
  }

  onMounted(() => {
    init()
  })

  return { MenuPrivateInstance }
}
